export default __webpack_public_path__ + "static/media/add.0750dbdc.svg";